const faqs = [
  {
    q: '妖精漫画网是免费的吗？需要注册吗？',
    a: '是的，妖精漫画网所有漫画资源完全免费在线阅读，无需注册或登录。打开网站即可畅享韩漫、日漫、国漫全部内容，真正做到零门槛阅读体验。',
  },
  {
    q: '妖精漫画网有哪些漫画类型？',
    a: '妖精漫画网大全覆盖韩漫、日漫、国漫三大品类，题材包括恋爱、奇幻、魔幻、悬疑、仙侠、治愈日常、古风宫斗等热门类型，满足各类漫画爱好者的阅读需求。',
  },
  {
    q: '漫画更新频率如何？追更能跟上进度吗？',
    a: '热门连载漫画保持每日更新节奏，与官方同步。下拉式阅读设计让追更体验流畅顺滑，无需反复翻页，阅读效率大幅提升，追更从此不等待。',
  },
  {
    q: '在手机上看漫画体验好吗？',
    a: '妖精漫画网采用响应式设计，完美适配手机、平板和电脑。移动端下拉式阅读体验尤其出色，竖屏浏览自然舒适，随时随地在线免费看漫画。',
  },
  {
    q: '可以推荐漫画给朋友吗？如何找到好看的漫画？',
    a: '可以通过人气排行、热门话题和专题推荐快速发现好看的漫画。我们的编辑团队每日精选优质内容，确保妖精漫画网好看的漫画随时可找、可读、可分享。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">关于妖精漫画网免费阅读的常见问题，你想知道的都在这里</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/60">
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-sm font-bold mt-0.5">
                  {i + 1}
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-10">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}